import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { chipTheme, chipSize } from './styles'

const Chip = ({ theme, style, mode = style, size, className, label, children, ...props }) => (
  // todo remove style once consumers have been updated
  <div className={cx(styles.chip, chipTheme(theme, mode), chipSize(size), className)} onMouseEnter={props.onMouseEnter}>
    {label ? <span>{label}</span> : children}
  </div>
)

Chip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small']),
  style: PropTypes.oneOf(['', 'light', 'dark']),
  mode: PropTypes.oneOf(['', 'light', 'dark']),
  className: PropTypes.string,
  onMouseEnter: PropTypes.func,
}

Chip.defaultProps = {
  theme: 'primary',
  size: 'small',
  style: 'light',
  mode: 'light',
}

export default Chip
